export function ConfirmationIcon() {
  return (
    <svg
      width="44"
      height="34"
      viewBox="0 0 44 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7 11L0 18L16.5 34L44 7L37 0L16.5 20.5L7 11Z" fill="#A5EB78" />
    </svg>
  );
}
